import $ from 'jquery';
import FederalBridgeFormula from 'src/federal_bridge_formula';
import AxlesCanvasOverweights from 'src/vehicle/chassis/axles_canvas_overweights';
import Alert from 'src/alert';

export default class AxlesWeightCheck extends FederalBridgeFormula {
  constructor(options = {}) {
    $(document).on('change', '[data-behavior~=select-state]', (event) => {
      const state = $(event.target).val();
      const id    = $(event.target).find('option:selected').data('id');

      this.addState(state, id);
    });

    $(document).on('click', '[data-behavior~=remove-state]', (event) => {
      event.preventDefault();

      this.removeState($(event.target));
    });

    $(document).on('click', 'button#mark', event => event.preventDefault());

    super(options);
  }

  addState(state, id) {
    const $statesEl                    = $('#states');
    const $axlesConfigurationContainer = $('#fbf-axles-configuration');

    if ($(`#state-${id}`).length) { return; }
    if (!$axlesConfigurationContainer.find('form#axles-weight-check')[0].reportValidity()) { return; }

    $('[data-behavior~=recheck-overweight]').show();

    $('#mock').remove();

    const stateHTML =
      `\
<div id='state-${id}' data-id='${id}' data-behavior='state-container'>
  <div class='panel panel-default'>
    <div class='panel-heading'>
      <div class='panel-title'>
        <span id='mark' title='Not checked yet'>
          <i class='fa fa-circle-o'></i>
        </span>
        <span>${state}</span>
        <span class='pull-right'>
          <a href='javascript: void(0)' title='Remove state panel'>
            <i class='fa fa-times-circle fa-lg text-danger' data-behavior='remove-state'></i>
          </a>
        </span>
      </div>

      <input type='text' name='axles_weight_check[states][]' value='${state}' hidden/>
    </div>
    <div class='panel-body' style='white-space: nowrap; overflow-x: auto;'>
      <span id='canvas-placeholder'>
        Processing ... In case of input errors, fix them and recheck axles overweight.
      </span>
    </div>
  </div>
</div>\
`;

    $statesEl.prepend(stateHTML);

    $axlesConfigurationContainer.find('form').submit();
  }

  removeState($el) {
    const $stateContainer  = $el.closest('[data-behavior~=state-container]');
    const $statesContainer = $('#states');

    $stateContainer.remove();

    if ($statesContainer.children().length === 0) {
      $('[data-behavior~=recheck-overweight]').hide();

      return $statesContainer.append(((() => `\
<span class="text-muted" id="mock">Select the states you want to check</span>\
`))()
      );
    }
  }

  handleAxlesConfigurationSubmit(event, $form) {
    if (!this.validateAxlesConfigurationForm($form[0])) {
      event.preventDefault();
      return false;
    }

    event.preventDefault();

    $.ajax({
      type: 'POST',
      url:  $form.attr('action'),
      data: $form.serialize(),
      success: xhr => {
        const $submitButton = $form.find('input[type=submit]');

        $submitButton.attr('disabled', false);
        $submitButton.removeClass('btn-primary');
        $submitButton.addClass('btn-default');
        $('#registration_prompt').removeClass('hidden');

        App.data.overweight_violations  = xhr.meta.overweight_violations;
        App.data.axles_group_thresholds = xhr.meta.axles_group_thresholds;

        this.vehicle.axlesCanvasOverweights = new AxlesCanvasOverweights({ vehicleId: this.vehicle.id });

        this.markStates();
      },
      error(xhr) {
        $form.find('input[type=submit]').attr('disabled', false);
        Alert.show(JSON.parse(xhr.responseText).error, 'danger');
      }
    });
  }

  markStates() {
    const violations = App.data.overweight_violations;

    $('#states').children().each((_, el) => {
      const $stateContainer    = $(el);
      const stateId            = $stateContainer.data('id');
      const $mark              = $stateContainer.find('#mark');
      const $canvasPlaceholder = $stateContainer.find('#canvas-placeholder');

      let violationClass = 'text-success';

      Object.values(violations[stateId]).forEach(function(el) {
        if (Number.isFinite(el.not_allowed.difference) && el.not_allowed.difference < 0) {
          violationClass = 'text-danger';
          return false;
        }

        if (Number.isFinite(el.legal.difference) && el.legal.difference < 0) {
          violationClass = 'text-warning';
          return false;
        }
      });

      $mark.replaceWith(((() => `\
<span id='mark'>
<i class='fa fa-circle ${violationClass}'></i>
</button>\
`))()
      );

      $canvasPlaceholder.html(((() => `\
<canvas id='${stateId}' width='2500px' height='140px'>\
`))()
      );

      this.vehicle.axlesCanvasOverweights.show(stateId);
    });
  }

  indicateInputsChanged() {
    $('form#axles-weight-check input[type=submit]').removeClass('btn-default');
    $('form#axles-weight-check input[type=submit]').addClass('btn-primary');
  }
};
